import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/cover_add.png';
import _imports_1 from '@/assets/imgs/bg_add.png';

const _withScopeId = n => (_pushScopeId("data-v-d8d2ebf8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "step-warp"
};
const _hoisted_2 = {
  class: "row-warp"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "cms-module-title"
};
const _hoisted_5 = {
  class: "table-form"
};
const _hoisted_6 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_7 = ["width"];
const _hoisted_8 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_9 = ["width"];
const _hoisted_10 = {
  class: "row-warp mg-b--20"
};
const _hoisted_11 = {
  class: "header"
};
const _hoisted_12 = {
  class: "cms-module-title"
};
const _hoisted_13 = {
  class: "picture-form"
};
const _hoisted_14 = {
  class: "tips"
};
const _hoisted_15 = {
  class: "cover-image-list"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_17 = {
  class: "upload-tips"
};
const _hoisted_18 = {
  class: "background-image-list"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_20 = {
  class: "upload-tips"
};
const _hoisted_21 = {
  class: "row-warp"
};
const _hoisted_22 = {
  class: "header"
};
const _hoisted_23 = {
  class: "cms-module-title"
};
const _hoisted_24 = {
  class: "picture-form"
};
const _hoisted_25 = {
  class: "tips"
};
const _hoisted_26 = {
  class: "cover-image-list"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_28 = {
  class: "upload-tips"
};
const _hoisted_29 = {
  class: "background-image-list"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_31 = {
  class: "upload-tips"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = {
  key: 1,
  style: {
    "width": "100%"
  }
};

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_35 = {
  class: "mg-l--5"
};
const _hoisted_36 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_37 = ["src", "alt"];
import BaseFormItem from './BaseFormItem.vue';
import ImageItem from '../../../../Components/ImageItem/index.vue';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import { getItemByProp } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { provide, inject, onMounted } from 'vue';
import { validatorNonNull, validateImageUrl } from '@/utils/validate';
import { getLangOptionsApi, getCloudDiskOptionsApi } from '@/api/vodNew';
import { useCommon } from '@/store/useCommon';
import { childModeOptions } from '@/assets/config/dicts';
import { getSysDictListApi } from '@/api/live';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props, {
    expose
  }) {
    const {
      t
    } = useI18n();
    const formDataRef = ref(null);
    const FormRef = ref(null);
    const imageItemRef = ref(null);
    const androidImageItemRef = ref(null);
    const cloudDiskOptions = ref();
    const vodCategoryList = ref([]);
    const finishData = inject('finishData');
    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '上传图片'
      },
      confirm: done => {
        let type = uploadFormConfig.formData.posterType == 'common' ? 'common' : 'android';
        FormRef.value.mForm.validate(valid => {
          if (valid) {
            if (dialogConfig.action === 'add') {
              if (type == 'common') {
                data.uploadType === 'cover' ? data.coverList.push({ ...uploadFormConfig.formData,
                  visualType: 'cover'
                }) : data.backgroundList.push({ ...uploadFormConfig.formData,
                  visualType: 'background'
                });
              } else {
                data.uploadType === 'cover' ? data.androidCoverList.push({ ...uploadFormConfig.formData,
                  visualType: 'cover'
                }) : data.androidBackgroundList.push({ ...uploadFormConfig.formData,
                  visualType: 'background'
                });
              }
            } else if (dialogConfig.action === 'edit') {
              if (uploadFormConfig.formData.type === 1) {
                uploadFormConfig.formData.url = '';
              } else {
                uploadFormConfig.formData.file = [];
              }

              const {
                currentImgIndex
              } = data;

              if (type == 'common') {
                data.uploadType === 'cover' ? data.coverList[currentImgIndex] = { ...uploadFormConfig.formData
                } : data.backgroundList[currentImgIndex] = { ...uploadFormConfig.formData
                };
              } else {
                data.uploadType === 'cover' ? data.androidCoverList[currentImgIndex] = { ...uploadFormConfig.formData
                } : data.androidBackgroundList[currentImgIndex] = { ...uploadFormConfig.formData
                };
              }

              if (finishData.value.posters && finishData.value.posters.length > 0 && uploadFormConfig.formData.id) {
                let fItem = finishData.value.posters.find(f => f.id == uploadFormConfig.formData.id);
                fItem ? fItem = { ...uploadFormConfig.formData
                } : '';
              }
            }

            dialogConfig.visible = false;
            console.log('确定上传图片了', data);
            done();
          } else {
            done();
          }
        });
      }
    });
    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      let lang = sessionStorage.getItem('seriesLang');

      if (lang) {
        languageOptions.value = JSON.parse(lang);
      } else {
        const res = await getLangOptionsApi();
        sessionStorage.setItem('seriesLang', JSON.stringify(res.data));
        languageOptions.value = res.data;
      }
    };

    const getVodProCategoryAttributes = async () => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi('vod_pro_type');

        if (code == 0) {
          vodCategoryList.value = data ? data : [];
        }
      } catch (error) {}
    };

    const validCategoryType = (rule, value, callback) => {
      if (!formConfig.otherData.categoryType) return callback(new Error(t('请选择内容类型')));
      callback();
    };

    const getCloudDiskOptions = async () => {
      const {
        code,
        data
      } = await getCloudDiskOptionsApi({
        name: useCommon().userData.name
      });

      if (code == 0) {
        cloudDiskOptions.value = data ? [...data] : [];
      }
    };

    provide('languageOptions', languageOptions);
    const formConfig = reactive({
      formList: [[{
        label: '系列片名称语言',
        prop: 'language',
        widgetType: 'Select',
        required: true,
        placeholder: '请选择语言',
        filterable: true,
        valueKey: 'name',
        labelKey: 'name',
        list: languageOptions,
        rules: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }]
      }, {
        label: '系列名称',
        prop: 'name',
        widgetType: 'input',
        required: true,
        placeholder: '请输入系列名称',
        showDelete: true,
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入系列名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: t('限制字符数量', {
            num: 50
          }),
          trigger: 'blur'
        }]
      }]],
      otherFormList: [[{
        label: '关联网盘',
        prop: 'cloudDiskAccountIdList',
        widgetType: 'multipleSelect',
        list: cloudDiskOptions,
        valueField: 'id',
        nameField: 'username',
        colspan: 3
      }], [{
        label: '归属模式',
        prop: 'childMode',
        widgetType: 'Select',
        required: true,
        list: childModeOptions
      }, {
        label: '内容分类',
        prop: 'categoryType',
        widgetType: 'Select',
        required: true,
        list: vodCategoryList,
        rules: {
          validator: validCategoryType,
          trigger: ['blur', 'change']
        }
      }]],
      formData: [{
        language: '',
        name: ''
      }],
      otherData: {
        cloudDiskAccountIdList: [],
        childMode: 0,
        categoryType: 'Movies'
      }
    });
    onMounted(() => {
      getCloudDiskOptions();
      getAllLanguages();
      getVodProCategoryAttributes();
      formConfig.formData[0].language = finishData.value.language;
      formConfig.formData[0].name = finishData.value.name;
      formConfig.formData = [...formConfig.formData, ...finishData.value.otherNameList];
      formConfig.otherData.cloudDiskAccountIdList = finishData.value.cloudDiskAccountIdList;
      formConfig.otherData.childMode = finishData.value.childMode || 0;
      formConfig.otherData.categoryType = finishData.value.categoryType || 'Movies';
      getCoverOrBgList();
    }); // 获取外层父组件提供的finishData数据 回显上传图片

    const getCoverOrBgList = () => {
      console.log('255-回显', finishData.value);

      if (finishData.value.posters && finishData.value.posters.length > 0) {
        finishData.value.posters.forEach(item => {
          if (item.visualType === 'cover') {
            // 封面图
            item.posterType == 'common' ? data.coverList.push({ ...item,
              url: item.imageUrl,
              type: item.type || 0
            }) : data.androidCoverList.push({ ...item,
              url: item.imageUrl,
              type: item.type || 0
            });
          } else if (item.visualType === 'background') {
            // 背景图
            item.posterType == 'common' ? data.backgroundList.push({ ...item,
              url: item.imageUrl,
              type: item.type || 0
            }) : data.androidBackgroundList.push({ ...item,
              url: item.imageUrl,
              type: item.type || 0
            });
          }
        });
      }
    };

    const data = reactive({
      imgVisible: false,
      dialogImageUrl: '',
      coverList: [],
      backgroundList: [],
      androidCoverList: [],
      androidBackgroundList: [],
      currentImgIndex: -1,
      operationList: [{
        src: require('@/assets/imgs/pic_search.png'),
        action: item => {
          data.imgVisible = true;
          data.dialogImageUrl = item.url ? item.url : item.file[0];
        }
      }, {
        src: require('@/assets/imgs/pic_edit.png'),
        action: (item, index) => {
          data.currentImgIndex = index;
          data.uploadType = item.visualType;
          uploadFormConfig.formData = { ...item
          };
          dialogConfig.visible = true;
          dialogConfig.action = 'edit';
          dialogConfig.config.title = '编辑';

          if (FormRef.value) {
            FormRef.value.mForm.clearValidate();
          }
        }
      }, {
        src: require('@/assets/imgs/pic_del.png'),
        action: (item, index) => {
          data.currentImgIndex = index;
          data.uploadType = item.visualType;

          if (item.posterType == 'common') {
            item.visualType === 'cover' ? data.coverList.splice(index, 1) : data.backgroundList.splice(index, 1);
          } else {
            item.visualType === 'cover' ? data.androidCoverList.splice(index, 1) : data.androidBackgroundList.splice(index, 1);
          }
        }
      }],
      uploadType: 'cover',
      formPictureData: {
        url: []
      },
      formAndroidPictureData: {
        url: []
      }
    });
    const uploadFormConfig = reactive({
      formList: [[{
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择语言',
        required: true,
        colspan: 3,
        valueKey: 'code',
        labelKey: 'name',
        list: languageOptions
      }], [{
        label: '海报类型',
        prop: 'posterType',
        widgetType: 'Select',
        filterable: true,
        required: true,
        colspan: 3,
        list: []
      }], [{
        label: '添加方式',
        prop: 'type',
        itemSlot: true,
        widgetType: 'input',
        colspan: 3
      }], [{
        label: '图片URL',
        prop: 'url',
        widgetType: 'tooltipInput',
        required: true,
        colspan: 3,
        controller: (value, data, config) => {
          return data.type === 1 ? false : true;
        }
      }], [{
        label: '文件',
        prop: 'file',
        itemSlot: true,
        required: true,
        widgetType: 'text',
        fileType: ['png', 'jpg'],
        accept: ".png,.jpg",
        colspan: 3,
        controller: (value, data, config) => {
          return data.type === 1 ? true : false;
        }
      }]],
      formData: {
        id: '',
        language: '',
        type: 1,
        url: '',
        file: [],
        imageBase64: '',
        visualType: '',
        posterType: 'common'
      },
      rules: {
        language: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        posterType: [{
          required: true,
          message: t('请选择海报类型'),
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: validateImageUrl,
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: t('请上传文件'),
          trigger: 'change'
        }]
      }
    }); // 添加方式 checkBox 点击事件

    const handleCheckChange = val => {
      uploadFormConfig.formData.type = val;
      uploadFormConfig.formData.url = '';
      uploadFormConfig.formData.file = [];
      uploadFormConfig.formData.imageBase64 = '';
    }; // 新增


    const addFormItem = () => {
      formConfig.formData.push({
        language: '',
        name: ''
      });
    }; // 删除


    const handleDeleteItem = index => {
      formConfig.formData.splice(index, 1);
    }; // 上传按钮点击事件


    const showDialog = (uploadType, type) => {
      uploadFormConfig.formData.posterType = type == 'default' ? 'common' : 'android';
      data.uploadType = uploadType;
      dialogConfig.config.title = '上传图片';
      dialogConfig.action = 'add';
      dialogConfig.visible = true;
    };

    const fileChange = file => {
      // 显示图标
      let reader = new FileReader(); //转base64

      reader.onload = function (e) {
        const res = e.target.result; // 将图片路径赋值给src

        uploadFormConfig.formData.file = [];
        uploadFormConfig.formData.file[0] = res;
        uploadFormConfig.formData.imageBase64 = res.split('base64,')[1];
        uploadFormConfig.formData.visualType = data.uploadType;
        FormRef.value.mForm.validateField('file');
      };

      reader.readAsDataURL(file.raw);
    };

    const handelRemove = file => {
      uploadFormConfig.formData.file = [];
      FormRef.value.mForm.validateField('file');
    };

    watch(() => dialogConfig.visible, val => {
      if (!val) {
        setTimeout(() => {
          uploadFormConfig.formData = {
            id: '',
            language: '',
            type: 1,
            url: '',
            file: [],
            imageBase64: '',
            visualType: '',
            posterType: 'common'
          };
        }, 200);
      } else {
        let item = getItemByProp(uploadFormConfig.formList, 'posterType');
        uploadFormConfig.formData.posterType == 'common' ? item.list = [{
          label: t('通用'),
          value: 'common'
        }] : item.list = [{
          label: t('安卓'),
          value: 'android'
        }];
      }

      if (FormRef.value) {
        FormRef.value.mForm.clearValidate();
      }
    });
    watch(() => data.coverList, val => {
      if (val && val.length > 0) {
        data.formPictureData.url = val;
        imageItemRef.value && imageItemRef.value.validateField('url');
      } else {
        data.formPictureData.url = [];
        imageItemRef.value && imageItemRef.value.validateField('url');
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => data.androidCoverList, val => {
      if (val && val.length > 0) {
        data.formAndroidPictureData.url = val;
        androidImageItemRef.value && androidImageItemRef.value.validateField('url');
      } else {
        data.formAndroidPictureData.url = [];
        androidImageItemRef.value && androidImageItemRef.value.validateField('url');
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      formDataRef,
      formConfig,
      data,
      imageItemRef,
      androidImageItemRef
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_MDialog = _resolveComponent("MDialog");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('基础信息')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: addFormItem
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('新增')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "formDataRef",
        ref: formDataRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("table", _hoisted_6, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['25%', '25%', '25%', '20%'], c => {
          return _createElementVNode("col", {
            width: c
          }, null, 8, _hoisted_7);
        }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.otherFormList || [], (formItem, formIndex) => {
          return _openBlock(), _createBlock(BaseFormItem, {
            key: formIndex,
            onDeleteItem: handleDeleteItem,
            "form-item": formItem,
            "form-data": formConfig.otherData,
            c_index: formIndex
          }, null, 8, ["form-item", "form-data", "c_index"]);
        }), 128))])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("table", _hoisted_8, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['25%', '25%', '25%', '20%'], c => {
            return _createElementVNode("col", {
              width: c
            }, null, 8, _hoisted_9);
          }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList || [], (formItem, formIndex) => {
            return _openBlock(), _createBlock(BaseFormItem, {
              key: formIndex,
              onDeleteItem: handleDeleteItem,
              "form-item": formItem,
              "form-data": formConfig.formData[index],
              c_index: index
            }, null, 8, ["form-item", "form-data", "c_index"]);
          }), 128))])])]);
        }), 128))]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('通用海报')), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1), _createElementVNode("div", _hoisted_15, [_createVNode(ImageItem, {
        "image-size": "224*168px",
        "image-style": "width:224px;height:168px",
        "img-list": data.coverList,
        "main-style": {
          width: '224px'
        },
        "operation-list": data.operationList,
        labelText: {
          language: '语言',
          name: '名称'
        }
      }, null, 8, ["img-list", "operation-list"]), _createVNode(_component_el_form, {
        model: data.formPictureData,
        ref_key: "imageItemRef",
        ref: imageItemRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "url",
          rules: [{
            required: true,
            message: _ctx.$t('请上传封面图片'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [data.coverList.length < 5 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "width": "224px",
              "height": "168px"
            },
            class: "upload-btn",
            onClick: _cache[0] || (_cache[0] = $event => showDialog('cover', 'default'))
          }, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('系列封面图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：224*168px", 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_18, [_createVNode(ImageItem, {
        "image-title": "系列背景图",
        "image-size": "1920*1080px",
        "image-style": "width:299px;height:168px",
        "main-style": {
          width: '299px'
        },
        "img-list": data.backgroundList,
        "operation-list": data.operationList,
        labelText: {
          language: '语言',
          name: '名称'
        }
      }, null, 8, ["img-list", "operation-list"]), data.backgroundList.length < 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "width": "299px",
          "height": "168px"
        },
        class: "upload-btn",
        onClick: _cache[1] || (_cache[1] = $event => showDialog('background', 'default'))
      }, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('系列背景图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：1920*1080px", 1)])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('安卓海报')), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1), _createElementVNode("div", _hoisted_26, [_createVNode(ImageItem, {
        "image-size": "224*168px",
        "image-style": "width:224px;height:168px",
        "img-list": data.androidCoverList,
        "main-style": {
          width: '224px'
        },
        "operation-list": data.operationList,
        labelText: {
          language: '语言',
          name: '名称'
        }
      }, null, 8, ["img-list", "operation-list"]), _createVNode(_component_el_form, {
        model: data.formAndroidPictureData,
        ref_key: "androidImageItemRef",
        ref: androidImageItemRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "url",
          rules: [{
            required: false,
            message: _ctx.$t('请上传封面图片'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [data.androidCoverList.length < 5 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "width": "224px",
              "height": "168px"
            },
            class: "upload-btn",
            onClick: _cache[2] || (_cache[2] = $event => showDialog('cover', 'android'))
          }, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('系列封面图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：224*168px", 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_29, [_createVNode(ImageItem, {
        "image-title": "系列背景图",
        "image-size": "1920*1080px",
        "image-style": "width:299px;height:168px",
        "main-style": {
          width: '299px'
        },
        "img-list": data.androidBackgroundList,
        "operation-list": data.operationList,
        labelText: {
          language: '语言',
          name: '名称'
        }
      }, null, 8, ["img-list", "operation-list"]), data.androidBackgroundList.length < 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "width": "299px",
          "height": "168px"
        },
        class: "upload-btn",
        onClick: _cache[3] || (_cache[3] = $event => showDialog('background', 'android'))
      }, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('系列背景图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：1920*1080px", 1)])])) : _createCommentVNode("", true)])])])]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogConfig.visible = $event),
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          ref_key: "FormRef",
          ref: FormRef,
          formRules: uploadFormConfig.rules,
          formData: uploadFormConfig.formData,
          col: ['15%', '35%', '15%', '35%']
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadFormConfig.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": uploadFormConfig.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'type' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
                "model-value": uploadFormConfig.formData.type === 1,
                onChange: _cache[4] || (_cache[4] = $event => handleCheckChange(1)),
                label: _ctx.$t('上传图片'),
                size: "large"
              }, null, 8, ["model-value", "label"]), _createVNode(_component_el_checkbox, {
                "model-value": uploadFormConfig.formData.type === 0,
                onChange: _cache[5] || (_cache[5] = $event => handleCheckChange(0)),
                label: _ctx.$t('输入URL'),
                size: "large"
              }, null, 8, ["model-value", "label"])])])) : _createCommentVNode("", true), scope.prop === 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [dialogConfig.visible ? (_openBlock(), _createBlock(ManuallyUpload, {
                key: 0,
                style: {
                  "width": "100%"
                },
                limit: 1,
                cover: "",
                fileType: scope.fileType,
                accept: scope.accept,
                onHandleChange: fileChange,
                onHandelRemove: handelRemove
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [_hoisted_34, _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('点击上传')), 1)]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["fileType", "accept"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_el_dialog, {
        modelValue: data.imgVisible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.imgVisible = $event),
        closeOnClickModal: false,
        title: _ctx.$t('预览')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%"
          },
          src: data.dialogImageUrl,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_37)])])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }

});